import * as React from 'react';
import { Grid, StyledComponentProps, Typography, List, FormControlLabel, Checkbox, ListItem } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import { IActions as ITrainerActions } from '../../../../common/store/trainers/actions/creators';
import SaveIconButton from '../../../../ui-components/Button/SaveIconButton';
import NewItemIconButton from '../../../../ui-components/Button/NewItemIconButton';
import DeleteIconButton from '../../../../ui-components/Button/DeleteIconButton';
import { Select } from '../../../../ui-components/select/Select';
import Tag from '../../../contacts/components/Tag/Tag';
import { trainer } from '../../../../model/trainer';
import { tag } from '../../../../model/tag';
import { contact } from '../../../../model/contact';
import { SearchBoxApi } from '../../../../ui-components/SearchBoxApi/SearchBoxApi';
import { invokeApi } from '../../../../common/networking/invoker';


interface IProps extends ITrainerActions, StyledComponentProps {
    trainer: trainer;
    isLoadingTrainer: boolean;
    saveTrainer: (trainer: trainer) => any;
    tags: tag[];
}

interface IState {
    trainer: trainer;
    contact?: contact;
}

const templateSearchBoxContact = (contact?: contact) => {
    return contact ? {
        label: (contact.surname ? contact.surname + " " + contact.name + " - " : "") + contact.email,
        value: contact
    } : undefined;
}

const searchContactsSearchBox = (search: string, take?: number): Promise<Array<contact>> => {
    return new Promise((resolve, reject) => {
        invokeApi({
            path: take ? `/api/Contacts?fullnameOrEmail=${search}&take=${take}`
                : `api/Contacts?fullnameOrEmail=${search}`,
            method: 'GET',
            responseType: "json",
        }).then(val => {
            resolve(val);
        }).catch(val => {
            reject(val)
        })
    })
}
// const getContact = (sub: string): Promise<contact> => {
//     return new Promise((resolve, reject) => {
//         invokeApi({
//             path: `/api/Contacts/${sub}`,
//             method: 'GET',
//             responseType: "json",
//         }).then(val => {
//             resolve(val);
//         }).catch(val => {
//             reject(val)
//         })
//     })
// }

export class Trainer extends React.Component<Partial<IProps>, IState> {
    state = { trainer: this.props.trainer, contact: undefined }
    // constructor(p, c) {
    //     super(p, c);
    //     this.state = {
    //         trainer: this.props.trainer
    //     }
    // }
    componentDidMount() {
        console.log("------------------------------------------------componentDidMount");
    }
    componentDidUpdate(prevProps: IProps) {
        // console.log("------------------------------------------------component DID UPDATE");
        // if (this.props.trainer.userId !== prevProps.trainer.userId) {
        //     console.log("------------------------------------------------" + this.props.trainer.userId);
        //     var cc = getContact(this.props.trainer.userId).then(c => {
        //         console.log("------------------------------------------------" + c);
        //         this.setState({contact: c});
        //     });
        //     //this.setState({ reminder: this.props.reminder });
        // }
    }
    handleIsActive = (checked: boolean) => {
        this.setState({ trainer: { ...this.state.trainer, isActive: checked } });
    }
    addContactItem = () => {
        this.setState({ trainer: { ...this.state.trainer, contactList: [...this.state.trainer.contactList, ''] } });
    }
    setContactListItem = (item: any, idx: any) => {
        // eslint-disable-next-line
        this.state.trainer.contactList[idx] = item;
        this.setState({ trainer: { ...this.state.trainer, contactList: [...this.state.trainer.contactList, ''] } });
    }
    deleteContactListItem = (idx: any) => {
        var array = [...this.state.trainer.contactList]; // make a separate copy of the array
        array.splice(idx, 1);
        this.setState({ trainer: { ...this.state.trainer, contactList: array } });
    }
    setTag = (item) => {
        var t = this.props.tags.find(t => t.code === item.value);
        var array = [];
        if (this.state.trainer.activityTags !== undefined) {
            array = [...this.state.trainer.activityTags];
        }
        array.push(t);
        this.setState({ trainer: { ...this.state.trainer, activityTags: array } });
    }
    deleteTagItem = (idx) => {
        var array = [...this.state.trainer.activityTags];
        array.splice(idx, 1);
        this.setState({ trainer: { ...this.state.trainer, activityTags: array } });
    }
    setContact = (c: contact) => {
        if (c !== undefined) {
            this.setState({ trainer: { ...this.state.trainer, userId: c.sub, userEmail: c.email } });
        }
        else {
            this.setState({ trainer: { ...this.state.trainer, userId: '', userEmail: '' } });
        }
    }
    render() {
        if (this.state.trainer?._id !== this.props.trainer?._id) {
            // controllo se la props è cambiata
            this.setState({ trainer: this.props.trainer });
        }
        return (this.state.trainer ?
            <Grid container spacing={1}>
                <Grid item sm={10} className={this.props.classes.nameSurnameContainer}>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            <TextField
                                label="Nome"
                                onChange={(val) => this.setState({ trainer: { ...this.state.trainer, name: val } })}
                                value={this.state.trainer.name}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={this.state.trainer.isActive}
                                        onChange={(e) => this.handleIsActive(e.target.checked)}
                                        value="1"
                                        color="primary"
                                    />
                                }
                                label="Istruttore Attivo Si/No"
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <Typography className={this.props.classes.sectionHeader} >
                                Info
                                <NewItemIconButton onClick={this.addContactItem} />
                            </Typography>
                            <List className={this.props.classes.root}>
                                {this.state.trainer?.contactList.map((c, i) =>
                                    <ListItem key={i} >
                                        <TextField
                                            value={c}
                                            onChange={(val) => { this.setContactListItem(val, i) }}
                                            InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                                        />
                                        <DeleteIconButton onClick={() => this.deleteContactListItem(i)} className={this.props.classes} disabled={false} />
                                    </ListItem>)
                                }
                            </List>
                        </Grid>
                        <Grid item sm={12} >
                            {/* <Typography className={this.props.classes.sectionHeader}>
                                Categorie
                            </Typography> */}
                            <Select fullWidth
                                selected={undefined}
                                items={this.props.tags.map(t => { return { name: t.description, value: t.code } })}
                                onChange={(item) => this.setTag(item)} label='Seleziona una categoria' />
                            <List disablePadding>
                                {this.state.trainer?.activityTags?.map((t, i) =>
                                    <ListItem key={i}>
                                        <Tag tag={t} />
                                        <DeleteIconButton onClick={() => this.deleteTagItem(i)} className={this.props.classes} disabled={false} />
                                    </ListItem>)
                                }
                            </List>
                        </Grid>
                        <Grid item sm={12}>
                            {/* <Typography className={this.props.classes.sectionHeader}>
                                Utente
                            </Typography> */}
                            <Grid item xs={12} style={{ margin: "5px" }}>
                                <SearchBoxApi<contact>
                                    selectedItem={this.state.contact}
                                    openOnFocus
                                    doFilter
                                    disabled={false} // props.addInProgress
                                    listSize={10}
                                    getItems={searchContactsSearchBox}
                                    label={"Utente"}
                                    placeholder={"Digitare cognome o nome"}
                                    templateItem={templateSearchBoxContact}
                                    onSelectedChange={(item) => { this.setContact(item) }} />
                            </Grid>
                            <TextField
                                label="UserId"
                                value={this.state.trainer.userId}
                                disabled
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                            <TextField
                                label="Email"
                                value={this.state.trainer.userEmail}
                                disabled
                                InputProps={{ classes: { disabled: this.props.classes.blackColor } }}
                            />
                        </Grid>
                        <Grid item sm={12}>
                            <SaveIconButton onClick={() => this.props.saveTrainer(this.state.trainer)} />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> : <></>
        )
    }
}
